const state = {
	modalScannerQr: {
		showModal: false,
		modalTittle: "",
		idModal:"",
		user: null,
		firstReservation:null
	},

	modalWalkin: {
		showModal: true,
		modalTittle: "prueba",
		idModal:"",
		user: {name: "Error"},
		reservation: {pax: "Error"},
		menuUrl: null
	},

	showComponentKiosk: '',
};

const getters = {
	modalScannerQr: state => {
		return state.modalScannerQr;
	},
	modalWalkin: state => {
		return state.modalWalkin;
	},
	showComponentKiosk: state => {
		return state.showComponentKiosk
	},
};

const mutations = {
	setModalScannerQr(state, payload) {
		state.modalScannerQr = payload.modalScannerQr;
	},
	setModalWalkin(state, payload) {
		state.modalWalkin = payload.modalWalkin;
	},
	setShowComponentKiosk(state, payload) {
		state.showComponentKiosk = payload;
	},
};

const actions = {
	saveSetShowComponentKiosk({commit}, status) {
		commit('setShowComponentKiosk', status)
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
};
